import { GoogleLogin } from './google-login';
import './social-login.scss';

export const SocialLogin = ({ redirect }: { redirect?: string }) => {
  return (
    <>
      <div className={'social_login_buttons'}>
        <GoogleLogin redirect={redirect}></GoogleLogin>
      </div>
    </>
  );
};
